import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { UNITS } from '@ordersnproducts/modules/shared/constants/units';

export namespace QuantityErrorOpenPlatformProvider {
  export class ErrorMessage extends BaseAsyncValue<string> {
    getValue(): Observable<string> {
      const translate: TranslateService = this.injector.get(TranslateService);
      const quantityFormControl = this.form.get(SpecFieldNames.QUANTITY);
      const statusChanges$ = quantityFormControl.statusChanges.pipe(
        map((status) => {
          if (
            quantityFormControl.invalid &&
            (quantityFormControl.hasError('incorrect') || quantityFormControl.hasError('min'))
          ) {
            const configObject = this.config as FieldInputNumberConfig;
            const message = `${translate.instant('views.specifications.min_values')}`.replace(
              '&',
              `${configObject.min} ${UNITS.CUBIC_METERS}`,
            );
            return message;
          }
          return null;
        }),
        takeUntil(this.ngDestroy),
      );
      return statusChanges$;
    }
  }
}
